<template>
  <div id="scrollbar">
    <div class="container-boxed">
      <ul class="navbar-nav h-100" id="navbar-nav">
        <li class="nav-item">
          <a
            class="nav-link"
            href="#sidebarModel"
            data-bs-toggle="collapse"
            role="button"
            aria-expanded="false"
            aria-controls="sidebarModel"
            style="padding-left: 0"
          >
            <i class="ri-layout-grid-line"></i>
            <span data-key="t-model"> 模型管理</span>
          </a>
          <div class="collapse menu-dropdown" id="sidebarModel">
            <ul class="nav nav-sm flex-column">
              <li class="nav-item">
                <router-link to="/model" class="nav-link" data-key="t-model">
                  产品库
                </router-link>
              </li>
              <li class="nav-item">
                <router-link to="/asset" class="nav-link" data-key="t-asset">
                  {{$t('overview_static.device')}}
                </router-link>
              </li>
            </ul>
          </div>
        </li>

        <li class="nav-item">
          <router-link
            class="nav-link menu-link"
            to="/data-integration"
            style="padding-left: 1.5rem"
          >
            <i class="ri-pie-chart-line"></i>
            <span data-key="t-data-integration">数据集成</span>
          </router-link>
        </li>

        <li class="nav-item">
          <router-link class="nav-link menu-link" to="/equipment-management">
            <i class="ri-layout-line"></i>
            <span data-key="t-equipment-management">设备管理</span>
          </router-link>
        </li>

        <li class="nav-item">
          <router-link class="nav-link menu-link" to="/iot/health-monitor">
            <i class="ri-focus-3-line"></i>
            <span data-key="t-health-monitor">健康监控</span>
          </router-link>
        </li>

        <li class="nav-item">
          <router-link class="nav-link menu-link" to="/iot/event-management">
            <i class="ri-file-text-line"></i>
            <span data-key="t-event-management">事件管理</span>
          </router-link>
        </li>

        <li class="nav-item">
          <router-link class="nav-link menu-link" to="/iot/atlas-analysis">
            <i class="ri-stack-line"></i>
            <span data-key="t-atlas-analysis">图谱分析</span>
          </router-link>
        </li>

        <li class="nav-item">
          <router-link class="nav-link menu-link" to="/iot/expert-system">
            <i class="ri-user-2-line"></i>
            <span data-key="t-expert-system">专家系统服务</span>
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>
